export const LAYOUT_TYPE_PINBOARD = 0;
export const LAYOUT_TYPE_CLASSIC = 1;
export const LAYOUT_TYPE_COMPACT = 2;
